import { StoreState } from '../store-interfaces';

export const selectAdAccounts = (state: StoreState) =>
  state.adAccounts.entities || [];
